import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { GrantAccountTransaction19one3d48lc6r as GrantAccountTransaction } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_at2gqzbsr4s5j1f as get_at,
  get_voided32ny3m7cav2w3 as get_voided,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { get_TCG_TIME_ZONEb89pisv39t5w as get_TCG_TIME_ZONE } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { atStartOfDayInq85k5urxn794 as atStartOfDayIn } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import {
  gte1zw995v5ulf70 as gte,
  lt30kf68e33bhtj as lt,
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { plus1oi9f9vif99u2 as plus } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from '../components/filters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.grants.GrantTransactionFilters', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('atStarts', true);
        tmp0_serialDesc.addElement_5pzumi_k$('atEnds', true);
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_mbcdui_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.atStarts_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.atStarts_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.atEnds_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.atEnds_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), value.voided_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_mbcdui_k$(encoder, value instanceof GrantTransactionFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GrantTransactionFilters().new_org_thecommunitygroupinc_cares_views_grants_GrantTransactionFilters_ue5u3x_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(LocalDateSerializer_getInstance()), get_nullable(LocalDateSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var GrantTransactionFiltersClass;
function GrantTransactionFilters() {
  if (GrantTransactionFiltersClass === VOID) {
    class $ {
      constructor(atStarts, atEnds, voided) {
        atStarts = atStarts === VOID ? null : atStarts;
        atEnds = atEnds === VOID ? null : atEnds;
        voided = voided === VOID ? null : voided;
        this.atStarts_1 = atStarts;
        this.atEnds_1 = atEnds;
        this.voided_1 = voided;
      }
      toCondition_oj74tc_k$() {
        var tmp = Always_getInstance();
        var tmp0_safe_receiver = this.atStarts_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          tmp_0 = gte(get_at(it), atStartOfDayIn(tmp0_safe_receiver, get_TCG_TIME_ZONE()));
        }
        var tmp_2 = tmp_0;
        var tmp1_safe_receiver = this.atEnds_1;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$11);
          tmp_3 = lt(get_at(it_0), atStartOfDayIn(plus(tmp1_safe_receiver, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)), get_TCG_TIME_ZONE()));
        }
        var tmp_5 = tmp_3;
        var tmp2_safe_receiver = this.voided_1;
        var tmp_6;
        if (tmp2_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_7;
          if (tmp2_safe_receiver) {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_8 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
            var tmp$ret$18 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_1 = new (DataClassPathSelf())(tmp$ret$18);
            tmp_7 = neq(get_voided(it_1), null);
          } else {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_9 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
            var tmp$ret$23 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_2 = new (DataClassPathSelf())(tmp$ret$23);
            tmp_7 = eq(get_voided(it_2), null);
          }
          tmp_6 = tmp_7;
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp, tmp_2, tmp_5, tmp_6]));
      }
      activeCount_htest3_k$() {
        var count = 0;
        if (!(this.atStarts_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.atEnds_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.voided_1 == null)) {
          count = count + 1 | 0;
        }
        return count;
      }
      copy_7mw2t7_k$(atStarts, atEnds, voided) {
        return new (GrantTransactionFilters())(atStarts, atEnds, voided);
      }
      copy$default_iz3kez_k$(atStarts, atEnds, voided, $super) {
        atStarts = atStarts === VOID ? this.atStarts_1 : atStarts;
        atEnds = atEnds === VOID ? this.atEnds_1 : atEnds;
        voided = voided === VOID ? this.voided_1 : voided;
        return $super === VOID ? this.copy_7mw2t7_k$(atStarts, atEnds, voided) : $super.copy_7mw2t7_k$.call(this, atStarts, atEnds, voided);
      }
      toString() {
        return 'GrantTransactionFilters(atStarts=' + toString(this.atStarts_1) + ', atEnds=' + toString(this.atEnds_1) + ', voided=' + this.voided_1 + ')';
      }
      hashCode() {
        var result = this.atStarts_1 == null ? 0 : this.atStarts_1.hashCode();
        result = imul(result, 31) + (this.atEnds_1 == null ? 0 : this.atEnds_1.hashCode()) | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : getBooleanHashCode(this.voided_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantTransactionFilters()))
          return false;
        if (!equals(this.atStarts_1, other.atStarts_1))
          return false;
        if (!equals(this.atEnds_1, other.atEnds_1))
          return false;
        if (!(this.voided_1 == other.voided_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_grants_GrantTransactionFilters_ue5u3x_k$(seen0, atStarts, atEnds, voided, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.atStarts_1 = null;
        else
          $this.atStarts_1 = atStarts;
        if (0 === (seen0 & 2))
          $this.atEnds_1 = null;
        else
          $this.atEnds_1 = atEnds;
        if (0 === (seen0 & 4))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        return $this;
      }
    }
    initMetadataForClass($, 'GrantTransactionFilters', GrantTransactionFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    GrantTransactionFiltersClass = $;
  }
  return GrantTransactionFiltersClass;
}
function grantTransactionFilters(_this__u8e3s4, target) {
  var tmp = grantTransactionFilters$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var this_0 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$('From');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_1 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (LocalDateField())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    var tmp = grantTransactionFilters$lambda$lambda;
    element_1.bind_gesskf_k$(element_1.content_1, target.lens_u4wb4z_k$(tmp, grantTransactionFilters$lambda$lambda_0));
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var this_2 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_2.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$('To');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_3 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (LocalDateField())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_3.willAddChild_hz2iwc_k$(element_3);
    var tmp_0 = grantTransactionFilters$lambda$lambda_1;
    element_3.bind_gesskf_k$(element_3.content_1, target.lens_u4wb4z_k$(tmp_0, grantTransactionFilters$lambda$lambda_2));
    element_3.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_4);
    element_4.set_content_lzqutq_k$('Voided');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_4 = themed(element_4, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_4.willAddChild_hz2iwc_k$(element_5);
    element_5.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_5 = weight(element_5, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Select())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_5.willAddChild_hz2iwc_k$(element_6);
    var tmp_1 = grantTransactionFilters$lambda$lambda_3;
    var tmp_2 = target.lens_u4wb4z_k$(tmp_1, grantTransactionFilters$lambda$lambda_4);
    var tmp_3 = _Constant___init__impl__v45mub(listOf([null, false, true]));
    element_6.bind_64a41i_k$(tmp_2, new (Constant())(tmp_3), grantTransactionFilters$lambda$lambda_5);
    element_6.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_6);
    element_5.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_5);
    element_4.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_4);
    return Unit_instance;
  });
}
function grantTransactionFilterChips(_this__u8e3s4, filter) {
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).atStarts_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = 'From: ' + renderToString(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp0_safe_receiver, tmp, grantTransactionFilterChips$lambda$slambda(filter)));
    }
    var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).atEnds_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = 'To: ' + renderToString(tmp1_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp1_safe_receiver, tmp_0, grantTransactionFilterChips$lambda$slambda_0(filter)));
    }
    var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).voided_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = tmp2_safe_receiver ? 'Voided' : 'Not voided';
      this_0.add_utx5q5_k$(new (FilterChip())(tmp2_safe_receiver, tmp_1, grantTransactionFilterChips$lambda$slambda_1(filter)));
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp = beforeSetup(this_0, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_0 = grantTransactionFilterChips$lambda;
  var tmp_1 = grantTransactionFilterChips$lambda_0;
  rowOf(tmp, chips, tmp_0, VOID, tmp_1, grantTransactionFilterChips$lambda_1);
}
function grantTransactionFilters$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $target.set_revjhg_k$(new (GrantTransactionFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function grantTransactionFilters$lambda$lambda(it) {
  return it.atStarts_1;
}
function grantTransactionFilters$lambda$lambda_0(old, new_0) {
  return old.copy$default_iz3kez_k$(new_0);
}
function grantTransactionFilters$lambda$lambda_1(it) {
  return it.atEnds_1;
}
function grantTransactionFilters$lambda$lambda_2(old, new_0) {
  return old.copy$default_iz3kez_k$(VOID, new_0);
}
function grantTransactionFilters$lambda$lambda_3(it) {
  return it.voided_1;
}
function grantTransactionFilters$lambda$lambda_4(old, new_0) {
  return old.copy$default_iz3kez_k$(VOID, VOID, new_0);
}
function grantTransactionFilters$lambda$lambda_5(it) {
  if (it == null)
    return 'All';
  return it ? 'Voided' : 'Not voided';
}
function grantTransactionFilterChips$lambda$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_iz3kez_k$(null);
  }), 1);
}
function grantTransactionFilterChips$lambda$slambda($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, grantTransactionFilterChips$lambda$slambda$slambda(), $completion);
    return Unit_instance;
  }), 1);
}
function grantTransactionFilterChips$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_iz3kez_k$(VOID, null);
  }), 1);
}
function grantTransactionFilterChips$lambda$slambda_0($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, grantTransactionFilterChips$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 1);
}
function grantTransactionFilterChips$lambda$slambda$slambda_1() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_iz3kez_k$(VOID, VOID, null);
  }), 1);
}
function grantTransactionFilterChips$lambda$slambda_1($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, grantTransactionFilterChips$lambda$slambda$slambda_1(), $completion);
    return Unit_instance;
  }), 1);
}
function grantTransactionFilterChips$lambda(it) {
  return to(it.value_1, it.label_1);
}
function grantTransactionFilterChips$lambda_0($this$rowOf) {
  return get_centered($this$rowOf);
}
function grantTransactionFilterChips$lambda_1($this$rowOf, item) {
  var tmp = lens(item, grantTransactionFilterChips$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, grantTransactionFilterChips$lambda$slambda_2(item));
  return Unit_instance;
}
function grantTransactionFilterChips$lambda$lambda(it) {
  return it.label_1;
}
function grantTransactionFilterChips$lambda$slambda_2($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  GrantTransactionFilters as GrantTransactionFilters1p8m9r9mmhdhp,
  grantTransactionFilterChips as grantTransactionFilterChips8s6tizmbhbwi,
  grantTransactionFilters as grantTransactionFilters1co3tl9cpy7v5,
};
//endregion

//# sourceMappingURL=GrantTransactionFilters.mjs.map
